const NavSign = (props) => {
  return (
    <div className={props.className}>
      <p>Sign in</p>
      <button type="button">Sign up</button>
    </div>
  );
};

export default NavSign;
